var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNewProductBadge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 41"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F977AD",
  stroke: "#3D3935",
  strokeWidth: 2,
  d: "M1 2.5a1 1 0 0 1 1-1h36a1 1 0 0 1 1 1v35.412a1 1 0 0 1-1.252.968l-16.992-4.427a3 3 0 0 0-1.512 0L2.252 38.88A1 1 0 0 1 1 37.912z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#3D3935",
  d: "M9.582 11.877h2l1.456 6.08v-6.08h1.888v11.904h-1.808l-1.648-6.528v6.528H9.582zm8.72 3.136c1.44 0 2.16.752 2.16 2.192v2.544h-2.735v1.872c0 .336.096.528.4.528.272 0 .368-.208.368-.528v-1.28h1.968v1.568c0 1.344-.944 2.032-2.16 2.032h-.384c-1.28 0-2.16-.704-2.16-2.032v-4.736c0-1.168.608-2.16 2.16-2.16zm-.575 2.16v1.04h.832v-1.04c0-.352-.08-.576-.416-.576-.368 0-.416.224-.416.576m6.63 6.608h-2.192l-1.296-8.608h2.016l.56 5.328.592-5.328h1.808l.576 5.392.56-5.392h1.92l-1.312 8.608h-2.128l-.56-4.672zm7.027-2.304v2.304H29.48v-2.304zm-2.112-9.6h2.32l-.752 9.232h-.816z"
})));
export default SvgNewProductBadge;